import {getAppDisplayName} from './appUtils';
import {CatalogApp, isReplitApp} from './catalogApp';

export const normalizeCatalogValue = (value: string) => value.trim().toLocaleLowerCase();

export const getCatalogAppAuthor = (app: CatalogApp): {label: string; value: string} | null => {
  const principal = app.owner?.principal;
  if (principal?.['.tag'] === 'user' && principal.username?.trim()) {
    const label = principal.username.trim();
    return {label, value: `user:${normalizeCatalogValue(label)}`};
  }
  if (principal?.['.tag'] === 'service' && principal.service_name?.trim()) {
    const label = principal.service_name.trim();
    return {label, value: `service:${normalizeCatalogValue(label)}`};
  }
  return null;
};

/** Normalized LDAP of the app's human author, or null for service-owned apps. */
export const getCatalogAppAuthorLdap = (app: CatalogApp): string | null => {
  const principal = app.owner?.principal;
  return principal?.['.tag'] === 'user' && principal.username?.trim()
    ? normalizeCatalogValue(principal.username)
    : null;
};

/**
 * Matches app name, slug, description, author LDAP, and author display name
 * (`authorNames` is keyed by normalized LDAP).
 */
export const searchCatalogApps = (
  apps: readonly CatalogApp[],
  query: string,
  authorNames: ReadonlyMap<string, string> = new Map()
): CatalogApp[] => {
  const normalizedQuery = normalizeCatalogValue(query);
  if (!normalizedQuery) return [...apps];

  return apps.filter((app) => {
    const author = getCatalogAppAuthor(app);
    const authorLdap = getCatalogAppAuthorLdap(app);
    const searchableValues = [
      getAppDisplayName(app),
      app.slug,
      author?.label,
      authorLdap ? authorNames.get(authorLdap) : undefined,
      isReplitApp(app) ? app.description : undefined,
    ];
    return searchableValues.some(
      (value) => value && normalizeCatalogValue(value).includes(normalizedQuery)
    );
  });
};
